import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { getDashboardUrl } from '../../utils/domainUtils';

const FinalCTA = () => {
  return (
    <section className="bg-slate-900 py-20 lg:py-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-4xl mx-auto text-center">
          {/* Headline */}
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white mb-6">
            Your Next 1-Star Review Is Preventable.
          </h2>

          {/* Subheadline */}
          <p className="text-xl text-slate-300 mb-10">
            See why UK venues are switching to real-time feedback.
          </p>

          {/* Buttons */}
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <span className="inline-flex items-center justify-center px-8 py-4 text-lg font-semibold text-white bg-slate-600 rounded-lg cursor-default">
              Start Free Trial
              <ArrowRight className="ml-2 w-5 h-5" />
            </span>
            <Link
              to="/pricing"
              className="inline-flex items-center justify-center px-8 py-4 text-lg font-semibold text-white bg-transparent border-2 border-white rounded-lg hover:bg-white/10 transition-all duration-200"
            >
              See Pricing
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FinalCTA;
